export default __webpack_public_path__ + "static/media/Ilogo.9c3ee17a.svg";